module.exports = __webpack_public_path__ + "static/media/007.d5cb3a80.jpg";